import type { PropsWithChildren, ReactElement } from 'react';
import styles from './PackageSection.module.scss';

type Props = PropsWithChildren<object>;

export function PackageSection(props: Props): ReactElement {
  return <div className={styles.container}>{props.children}</div>;
}
